/** Initial state */
const initialState = {
  proposal_info: {},
  unread_messages: 0,
  selected_expense_item: {},
  loading: false,
  modalShow: false,
  data: null,
  error: null,
  expenseItemCode: "",
  treeStore: [],
  reductionProposalTreeStore: [],
  treeStoreDashboard: [],
  costInfoTreeList: [],
  checkedExpItemCodeArray: [],
  industryStore: [],
  selected_industry_item: {},
  task_data: {},
  checkedExpItemCodeArrayDashboard: [],
  selecetdClientData: [],
  selectedQuotationNo: [],
  selectedAggrementNo: [],
  sessionQA: [],
  judgePoint: {},
  expenseMasterData: {},
  judgeResult: {},
  selectAssesmentNo: "",
  expenseYMData: {},
  linkageInfoNo: "",
  personModeAndData: { person_id: "", isEditmode: false },
  supplierData: {},
  reductionProposalData: {},
  downloadAcquisitionData: {},
  journalImportData: {},
  excellentPoint: "",
  expense_item_year : {}
};
/**
 * Common mutations
 */
const mutations = {
  PROPOSAL_INFO_UPDATE(state, payload) {
    Object.assign(state.proposal_info, payload);
  },
  EXPENSE_MASTER_DATA(state, payload) {
    Object.assign(state.expenseMasterData, payload);
  },
  DOWNLOAD_ACQUISITION_DATA(state, payload) {
    Object.assign(state.downloadAcquisitionData, payload);
  },
  UNREAD_MESSAGES_UPDATE(state, payload) {
    state.unread_messages = payload.unread_messages;
  },
  SET_EXPENSE_CODE(state, payload) {
    state.expenseItemCode = payload.expenseItemCode;
  },
  SELECTED_EXPENSE_ITEM(state, payload) {
    Object.assign(state.selected_expense_item, payload);
  },
  SET_TASK_DATA(state, payload) {
    Object.assign(state.task_data, payload);
  },
  UPDATE_TREE_STORE(state, newTree) {
    state.treeStore = newTree;
  },
  UPDATE_EXPENSE_ITEM_YEAR(state,expenseItemYear){
    state.expense_item_year = expenseItemYear;
  },
  UPDATE_REDUCTION_PROPOSAL_TREE_STORE(state, reductionProposalTree) {
    state.reductionProposalTreeStore = reductionProposalTree;
  },
  UPDATE_TREE_STORE_DASHBOARD(state, newTree) {
    state.treeStoreDashboard = newTree;
  },
  UPDATE_COST_INFO_TREELIST(state, newCOSTINFO) {
    state.costInfoTreeList = newCOSTINFO;
  },
  UPDATE_EXP_ITEM_CODE_ARRAY(state, newCheckedExpItemCodeArray) {
    state.checkedExpItemCodeArray = newCheckedExpItemCodeArray;
  },
  UPDATE_EXPITEM_CODE_ARRAY_IN_DASHBOARD(state, newCheckedExpItemCodeArray) {
    state.checkedExpItemCodeArrayDashboard = newCheckedExpItemCodeArray;
  },
  SELECTED_INDUSTRY_ITEM(state, payload) {
    Object.assign(state.selected_industry_item, payload);
  },
  UPDATE_INDUSTRY_TREE_STORE(state, newTree) {
    state.industryStore = newTree;
  },
  SET_CLIENT_DATA(state, payload) {
    state.selecetdClientData = payload;
  },
  SET_QUOTATION_NO(state, payload) {
    state.selectedQuotationNo = payload;
  },
  SET_AGGREMENT_NO(state, payload) {
    state.selectedAggrementNo = payload;
  },
  SET_ASSESMENT_NO(state, payload) {
    state.selectAssesmentNo = payload;
  },
  SESSION_QUESTION_ANSWER(state, payload) {
    state.sessionQA = payload;
  },
  SESSION_JUDGEMENT_POINT(state, payload) {
    Object.assign(state.judgePoint, payload);
  },
  SESSION_JUDGEMENT_RESULT(state, payload) {
    Object.assign(state.judgeResult, payload);
  },
  EXPENSE_YM_DATA(state, payload) {
    state.expenseYMData = payload;
  },
  LINKAGE_INFO_NO(state, payload) {
    state.linkageInfoNo = payload;
  },
  SET_PERSON_AND_MODE(state, payload) {
    state.personModeAndData = payload;
  },
  SET_SUPPLIER_DATA(state, payload) {
    state.supplierData = payload;
  },
  SET_SUPPLIER_REDUCTION_PROPOSAL_DATA(state, payload) {
    state.reductionProposalData = payload;
  },
  SET_JOURNAL_IMPORT_DATA(state, payload) {
    state.journalImportData = payload;
  },
  SET_EXCELLENT_POINT(state, payload) {
    state.excellentPoint = payload;
  },
};
/**
 * Common actions
 */
const actions = {
  //proposal info
  updateProposalInfo(context, proposalInfo) {
    context.commit("PROPOSAL_INFO_UPDATE", proposalInfo);
  },
  updateExpenseItemYear(context, expenseItemYear) {
    context.commit("UPDATE_EXPENSE_ITEM_YEAR", expenseItemYear);
  },
  updateMasterData(context, expenseMasterData) {
    context.commit("EXPENSE_MASTER_DATA", expenseMasterData);
  },
  updateDownloadData(context, downloadData) {
    context.commit("DOWNLOAD_ACQUISITION_DATA", downloadData);
  },
  updateLinkageInfoNo(context, linkageInfoNo) {
    context.commit("LINKAGE_INFO_NO", linkageInfoNo);
  },
  //updateSessioQuestionAnswers
  updateSessionQA(context, sessionQuestionAnswer) {
    context.commit("SESSION_QUESTION_ANSWER", sessionQuestionAnswer);
  },
  //updateJudgementPoint Fetch result
  updateJudgementResult(context, sessionJudgementResult) {
    context.commit("SESSION_JUDGEMENT_RESULT", sessionJudgementResult);
  },
  //updateSessionJudgementPoint
  updateJudgementPoint(context, sessionJudgementPoint) {
    context.commit("SESSION_JUDGEMENT_POINT", sessionJudgementPoint);
  },
  //Unread messages batch count
  updateUnreadMessages(context, unreadMessages) {
    context.commit("UNREAD_MESSAGES_UPDATE", unreadMessages);
  },
  setExpenseCode(context, expenseItemCode) {
    context.commit("SET_EXPENSE_CODE", expenseItemCode);
  },
  /**update selected expense item from list screen */
  updateSelectedExpenseItem(context, selectedExpenseItem) {
    context.commit("SELECTED_EXPENSE_ITEM", selectedExpenseItem);
  },
  updateTree(context, tree) {
    context.commit("UPDATE_TREE_STORE", tree);
  },
  updateReductionProposalTree(context, reductionTree) {
    context.commit("UPDATE_REDUCTION_PROPOSAL_TREE_STORE", reductionTree);
  },
  updateTreeDashboard(context, tree) {
    context.commit("UPDATE_TREE_STORE_DASHBOARD", tree);
  },
  costInfoTreeList(context, CostInfoTree) {
    context.commit("UPDATE_COST_INFO_TREELIST", CostInfoTree);
  },
  updateCheckedExpItemCodeArray(context, checkedExpItemCode) {
    context.commit("UPDATE_EXP_ITEM_CODE_ARRAY", checkedExpItemCode);
  },
  updateCheckedExpItemCodeArrayInDasboard(context, checkedExpItemCode) {
    context.commit(
      "UPDATE_EXPITEM_CODE_ARRAY_IN_DASHBOARD",
      checkedExpItemCode
    );
  },

  updateselectedIndustryItem(context, selectedIndustryItem) {
    context.commit("SELECTED_INDUSTRY_ITEM", selectedIndustryItem);
  },
  updateIndustryTree(context, tree) {
    context.commit("UPDATE_INDUSTRY_TREE_STORE", tree);
  },
  updateTaskData(context, taskDetails) {
    context.commit("SET_TASK_DATA", taskDetails);
  },
  setClientData(context, clientData) {
    context.commit("SET_CLIENT_DATA", clientData);
  },
  setQuotationNo(context, quotationNo) {
    context.commit("SET_QUOTATION_NO", quotationNo);
  },
  setAggrementNo(context, aggrementNo) {
    context.commit("SET_AGGREMENT_NO", aggrementNo);
  },
  setAssesmentNo(context, assesmentNo) {
    context.commit("SET_ASSESMENT_NO", assesmentNo);
  },
  updateYMData(context, expenseYMData) {
    context.commit("EXPENSE_YM_DATA", expenseYMData);
  },
  /**update selected edit mode and person data */
  updatePersonAndMode(context, selectedPersonData) {
    context.commit("SET_PERSON_AND_MODE", selectedPersonData);
  },
  updateSupplierData(context, supplier) {
    context.commit("SET_SUPPLIER_DATA", supplier);
  },
  updateSupplierReductionProposal(context, reductionProposal) {
    context.commit("SET_SUPPLIER_REDUCTION_PROPOSAL_DATA", reductionProposal);
  },
  updateJournalImport(context, journalImport) {
    context.commit("SET_JOURNAL_IMPORT_DATA", journalImport);
  },
  updateExcellentPoint(context, excellentPoint) {
    context.commit("SET_EXCELLENT_POINT", excellentPoint);
  },
};
/** Data getters */
const getters = {
  getMasterData(state) {
    return state.expenseMasterData;
  },
  getExpenseItemYear(state){
    return state.expense_item_year;
  },
  getLinkageInfoNo(state) {
    return state.linkageInfoNo;
  },
  getDownloadedData(state) {
    return state.downloadAcquisitionData;
  },
  getSessionQA(state) {
    return state.sessionQA;
  },
  getSessionJudgementPoint(state) {
    return state.judgePoint;
  },
  getSessionJudgementResult(state) {
    return state.judgeResult;
  },
  getProposalInfo(state) {
    return state.proposal_info;
  },
  getUnreadMessages(state) {
    return state.unread_messages;
  },
  getExpenseItemCode(state) {
    return state.expenseItemCode;
  },
  getSelectedExpenseItem(state) {
    return state.selected_expense_item;
  },
  getTaskDetails(state) {
    return state.task_data;
  },
  getTree(state) {
    return state.treeStore;
  },
  getReductionProposalTree(state) {
    return state.reductionProposalTreeStore;
  },
  getTreeDashboard(state) {
    return state.treeStoreDashboard;
  },
  getCostInfoTreeList(state) {
    return state.costInfoTreeList;
  },
  getCheckedExpItemCodeArray(state) {
    return state.checkedExpItemCodeArray;
  },
  getIndustryTree(state) {
    return state.industryStore;
  },
  getSelectedIndustryItem(state) {
    return state.selected_industry_item;
  },
  getCheckedExpItemCodeArrayInDashboard(state) {
    return state.checkedExpItemCodeArrayDashboard;
  },
  getClientData(state) {
    return state.selecetdClientData;
  },
  getQuotationNo(state) {
    return state.selectedQuotationNo;
  },
  getAggrementNo(state) {
    return state.selectedAggrementNo;
  },
  getAssesmentNo(state) {
    return state.selectAssesmentNo;
  },
  getExpenseYMData(state) {
    return state.expenseYMData;
  },
  getPersonDataAndMode(state) {
    return state.personModeAndData;
  },
  getSupplierData(state) {
    return state.supplierData;
  },
  getSupplierReductionProposalData(state) {
    return state.reductionProposalData;
  },
  getJournalImportData(state) {
    return state.journalImportData;
  },
  getExcellentPoint(state) {
    return state.excellentPoint;
  },
};
export default {
  mutations,
  actions,
  state: initialState,
  getters,
};
